import { render, staticRenderFns } from "./TableAbastoConfigComponents.vue?vue&type=template&id=b4c67cf6&scoped=true"
import script from "./TableAbastoConfigComponents.vue?vue&type=script&lang=js"
export * from "./TableAbastoConfigComponents.vue?vue&type=script&lang=js"
import style0 from "./TableAbastoConfigComponents.vue?vue&type=style&index=0&id=b4c67cf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c67cf6",
  null
  
)

export default component.exports